import EconomicLoss from "./EconomicLoss";
import ExperiencedAfter from "./ExperiencedAfter";
import Position from "./Position";

export default class Employment {
	constructor() {
		this.employmentId = null;
		this.claimDetailsId = null;
		this.stateId = null;
		this.harrassmentDetails = null;
		this.harassmentReported = null;
		this.harrassmentReportedTo = null;
		this.complaintResolved = null;
		this.complaintSatisfied = null;
		this.additionalInformation = null;
		this.sufferEconomicLoss = null;
		this.economicLossAdditional = null;
		this.didExperiencedAfter = null;
		this.experiencedAfterAdditional = null;
		this.positions = [new Position()];
		this.economicLoss = [];
		this.experiencedAfter = [];
	}
}
